import { useState } from "react";
import { toast } from "sonner";
import { RESULTADOS_RAPIDOS, postResultadoRapido, mensajeResultadoError, olvidarIntento } from "../../lib/notas";

/**
 * Resultado de la llamada en un toque, junto al número: no contestó / buzón / contestó / número malo.
 * Solo aparece si hay un intento propio reciente para ese número (se guardó al elegir cuenta en «¿por dónde llamar?»).
 */
export default function ResultadoRapido({ phone, attemptId, onResultado }) {
  const [enviando, setEnviando] = useState("");
  if (!attemptId) return null;

  const tocar = async (result) => {
    if (enviando) return;
    setEnviando(result);
    try {
      const r = await postResultadoRapido(attemptId, result);
      if (!r.already) onResultado?.(phone, r.counter || null);
      olvidarIntento(phone);
    } catch (e) {
      toast.error(mensajeResultadoError(e));
      if (e?.response?.status === 404 || e?.response?.status === 409) olvidarIntento(phone);
    } finally {
      setEnviando("");
    }
  };

  return (
    <span className="nt-resrap" data-testid="nt-resultado-rapido" onClick={(e) => e.stopPropagation()}>
      {RESULTADOS_RAPIDOS.map((r) => (
        <button type="button" key={r.key} className="nt-resrap-b" title={r.label} aria-label={r.label}
          data-testid={`nt-resultado-${r.key}`} disabled={!!enviando} onClick={() => tocar(r.key)}>
          {enviando === r.key ? "…" : r.corto}
        </button>
      ))}
    </span>
  );
}
